package de.oevbs.kunde.kundenportal2.components

import de.oevbs.businesspartner.bpcrmservice2.common.model.CRMDocument
import de.oevbs.kosmos.ui.elements.button.Btn
import de.oevbs.kosmos.ui.elements.button.btn
import de.oevbs.kosmos.ui.icons.CustomIcons
import de.oevbs.kunde.kundenportal2.PortalMessages
import de.oevbs.kunde.kundenportal2.authentication.PortalSessionMiddleware
import de.oevbs.kunde.kundenportal2.model.services.document.DocumentClientDefinition
import de.oevbs.sfa.communication.sfaServiceOrigin
import de.oevbs.sfa.communication.use
import dev.fritz2.core.RenderContext
import io.ktor.client.*
import io.ktor.client.engine.js.*
import kotlinx.browser.window
import org.khronos.webgl.Uint8Array
import org.w3c.dom.url.URL
import org.w3c.files.Blob
import org.w3c.files.BlobPropertyBag

private object DocumentClient : DocumentClientDefinition(window.location.sfaServiceOrigin) {
    override val client: HttpClient = HttpClient(Js, config)

    init {
        use(PortalSessionMiddleware)
    }
}

/**
 * Komponente zur Darstellung eines Download-Knopfs zum Herunterladen eines PDF-Dokuments.
 *
 * @param document Das [CRMDocument] mit den Pfadinformationen
 */
fun RenderContext.pdfDownloadButton(document: CRMDocument) {
    renderPdfDownloadButton(document.title) {
        val response = DocumentClient.getDocument(document.documentId, document.contentRepositoryId, document.title)
        if (response.isSuccess) {
            val newWindow = window.open()
            newWindow?.location?.href = createPdfObjectUrl(response.getOrThrow())
        } else {
            GlobalServiceMessagesStore.add(PortalMessages.notFound)
        }
    }
}

fun Uint8Array.Companion.from(arrayLike: String, mapFn: (String) -> Int) =
    asDynamic().from(arrayLike, mapFn).unsafeCast<Uint8Array>()

@Suppress("NOTHING_TO_INLINE")
inline fun String.charCodeAt(index: Int) = asDynamic().charCodeAt(index).unsafeCast<Int>()

/**
 * Erzeugt eine [Object-URL][URL] für ein PDF-Dokument aus einem base64-kodierten [String].
 *
 * Weil eine Object-URL nur aus einem [Blob] erzeugt werden kann, wird der String zuerst dekodiert und dann byteweise in
 * ein [Uint8Array] gelesen, aus dem im Anschluss ein [Blob] mit dem korrekten MIME-Type erzeugt wird.
 *
 * @param base64Data das PDF-Dokument Base64 kodiert
 */
fun createPdfObjectUrl(base64Data: String): String {
    val byteString = window.atob(base64Data)
    val bytes = Uint8Array.from(byteString) { it.charCodeAt(0) }
    val blob = Blob(arrayOf(bytes), BlobPropertyBag(type = "application/pdf"))
    return URL.createObjectURL(blob)
}

/**
 * Komponente zur Darstellung eines Download-Knopfs zum Herunterladen eines PDF-Dokuments aus dem `formularcenter2`.
 *
 * @param urlSearchSegment das URL-Segment, welches den API-Call zum `formularcenter` enthält. Also z.B.
 * `/formular-center2/Suche?unid=1fffee5d0a5e08a6c125882100376291&dok=HUS_HBB_63_2022-05.pdf&`
 * @param title der Text des Buttons und der Titel des neuen Tabs
 */
fun RenderContext.pdfDownloadButton(urlSearchSegment: String, title: String) {
    renderPdfDownloadButton(title) {
        window.open(window.location.sfaServiceOrigin + urlSearchSegment, title)
    }
}

private fun RenderContext.renderPdfDownloadButton(title: String, handle: suspend () -> Unit) = btn {
    icon(CustomIcons.document_pdf)
    label(title)
    variant = Btn.Variant.Ghost
}.clicks handledBy {
    handle()
}